import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { useAuthContext } from 'AuthContext';
import { useMeetingHubContext } from '../MeetingHubContext';

const GreetingSection: React.FunctionComponent = () => {
  const { profile, isStaff } = useAuthContext();
  const { isPresidingChair } = useMeetingHubContext();

  return (
    <Box display="flex" alignItems={'center'} gap={1}>
      <Typography variant="subtitle2">
        Hello, {profile?.customer.firstname} {profile?.customer.lastname}
      </Typography>
      {isStaff && <Chip label="Staff" color="secondary" size="small" />}
      {isPresidingChair && <Chip label="Presiding Chair" color="secondary" size="small" />}
    </Box>
  );
};

export default GreetingSection;
